import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  HStack,
  Spinner,
  Text,
} from "@chakra-ui/react"
import { useWarehouseInventoryBlocks } from "../../../hooks/useWarehouseInventoryBlocks"

export function InventoryBlockReadNotice() {
  const query = useWarehouseInventoryBlocks()
  if (query.isSuccess) return null
  return (
    <Alert
      status={query.isPending ? "info" : "warning"}
      borderRadius="md"
      alignItems="start"
      mb={3}
    >
      <AlertIcon />
      <HStack justify="space-between" align="start" w="full" flexWrap="wrap">
        <div>
          <AlertTitle>
            {query.isPending
              ? "Sprawdzanie blokad inwentaryzacyjnych"
              : "Nie można sprawdzić blokad inwentaryzacyjnych"}
          </AlertTitle>
          <AlertDescription>
            <Text>
              Stan magazynów jest nieznany. Operacje zależne od magazynu
              pozostają zablokowane do potwierdzenia odczytu.
            </Text>
          </AlertDescription>
        </div>
        <Button
          size="sm"
          onClick={() => void query.refetch()}
          isLoading={query.isFetching}
          isDisabled={query.isPending}
        >
          {query.isPending ? (
            <>
              <Spinner size="xs" mr={2} />
              Sprawdzanie
            </>
          ) : (
            "Spróbuj ponownie"
          )}
        </Button>
      </HStack>
    </Alert>
  )
}
